import { useEffect, useRef, useState } from "react";
import { thumbUrl } from "./photos";

/**
 * A car's cover shot at list size.
 *
 * Each image is fetched as the signed-in user, because the bucket is private,
 * and turned into a local blob URL that is revoked on unmount. A vehicle with
 * no photo gets an empty frame rather than a gap, so rows stay aligned.
 */
export default function VehicleThumb({ path, alt }: {
  path: string | undefined;
  alt: string;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const owned = useRef<string | null>(null);

  useEffect(() => {
    let live = true;
    if (!path) { setUrl(null); return; }
    thumbUrl(path)
      .then((u) => {
        if (!live) { URL.revokeObjectURL(u); return; }
        owned.current = u;
        setUrl(u);
      })
      .catch(() => { /* no picture is not an error worth showing in a list */ });
    return () => {
      live = false;
      if (owned.current) { URL.revokeObjectURL(owned.current); owned.current = null; }
    };
  }, [path]);

  if (!path) return <span className="thumb thumb-none" aria-hidden="true" />;
  return url
    ? <img className="thumb" src={url} alt={alt} loading="lazy" />
    : <span className="thumb thumb-none" aria-hidden="true" />;
}
